import { Link } from "react-router-dom";
import LiveCard from "@/components/base/LiveCard";
import SectionTitle from "@/components/base/SectionTitle";
import { liveItems } from "@/mocks/lives";
import { sortLives } from "@/utils/live";

export default function LatestLives() {
  const latest = sortLives(liveItems, "new").slice(0, 8);

  return (
    <section className="w-full bg-background-100/50">
      <div className="mx-auto w-full max-w-[1440px] px-4 py-12 md:px-6 md:py-16">
        <SectionTitle
          eyebrow="Live Now"
          title="最新直播"
          desc="实时更新的直播内容，游戏、娱乐、体育一网打尽"
          action={
            <Link
              to="/channels"
              className="inline-flex items-center gap-1 whitespace-nowrap rounded-md border border-background-300 bg-background-100 px-4 py-2 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-500/60"
            >
              查看全部
              <i className="ri-arrow-right-line" />
            </Link>
          }
        />
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {latest.map((item) => (
            <LiveCard key={item.id} item={item} />
          ))}
        </div>
      </div>
    </section>
  );
}